















import { Component, Vue } from "vue-property-decorator";

@Component
export default class ManageRules extends Vue {
  public created() {
    console.log("manage rules created")
  }}
